import { CardMetricsConfig } from '@nbx/components';

import { Metric } from '../interfaces/metric.interface';

export const ENERGY_METRICS: CardMetricsConfig[] = [
  {
    type: 'metric',
    title: 'METRICS.TOTAL_CONSUMPTION.TITLE',
    metric: {
      value: '0',
      suffix: ' kWh',
    },
    tag: {
      severity: 'danger',
      label: `METRICS.TEMPORALITY.LAST_WEEK`,
      value: `0%`,
    },
    icon: 'pi pi-chart-line',
    hint: 'HOME.ENERGY_METRICS.TOTAL_CONSUMPTION.DESCRIPTION',
    severity: 'danger',
  },
  {
    type: 'metric',
    title: 'METRICS.ESTIMATED_COST.TITLE',
    metric: {
      value: 0,
      suffix: ' $',
    },
    tag: {
      severity: 'danger',
      label: 'METRICS.TEMPORALITY.LAST_WEEK',
      value: `0%`,
    },
    icon: 'pi pi-money-bill',
    hint: 'HOME.ENERGY_METRICS.ESTIMATED_COST.DESCRIPTION',
    severity: 'danger',
  },
];

export const ENERGY_METRICS_OVERAL_VIEW: CardMetricsConfig[] = [
  ...ENERGY_METRICS,
  {
    type: 'metric',
    title: 'METRICS.PEAK_CONSUMPTION.TITLE',
    metric: {
      value: '0',
      suffix: ' kWh',
    },
    tag: {
      severity: 'warn',
      label: `METRICS.TEMPORALITY.PEAK_AT`,
      value: `00:00`,
      labelPosition: 'after',
    },
    icon: 'pi pi-chart-line',
    hint: 'RENTAL.OVERALL.DASHBOARD.ENERGY_METRICS.PEAK_CONSUMPTION.DESCRIPTION',
    severity: 'danger',
  },
];

export const ENERGY_DISTRIBUTION_OVERAL: CardMetricsConfig[] = [
  {
    type: 'chart',
    title: 'METRICS.DISTRIBUTION_AREA.AREAS.AC',
    metric: { value: 0, suffix: '%' },
    subtitle: '0 kWh',
    severity: 'home',
  },
  {
    type: 'chart',
    title: 'METRICS.DISTRIBUTION_AREA.AREAS.KITCHEN',
    metric: { value: 0, suffix: '%' },
    subtitle: '0 kWh',
    severity: 'home',
  },
  {
    type: 'chart',
    title: 'METRICS.DISTRIBUTION_AREA.AREAS.LIGHTING',
    metric: { value: 0, suffix: '%' },
    subtitle: '0 kWh',
    severity: 'home',
  },
  {
    type: 'chart',
    title: 'METRICS.DISTRIBUTION_AREA.AREAS.OUTDOOR',
    metric: { value: 0, suffix: '%' },
    subtitle: '0 kWh',
    severity: 'home',
  },
];

export const ENERGY_DISTRIBUTION: CardMetricsConfig[] = [
  ...ENERGY_DISTRIBUTION_OVERAL,
  {
    type: 'chart',
    title: 'METRICS.DISTRIBUTION_AREA.AREAS.OTHER',
    metric: { value: 0, suffix: '%' },
    subtitle: '0 kWh',
    severity: 'home',
  },
];

export const ENERGY_METRICS_GRID_CONFIG = {
  title: 'HOME.ENERGY_METRICS.HEADING',
  primary: {
    title: 'Title dentro de primary',
    content: {
      kind: 'metrics',
      items: ENERGY_METRICS ?? [],
    },
  },
  secondary: {
    title: 'HOME.ENERGY_METRICS.DISTRIBUTION_AREA.HEADING',
    content: {
      kind: 'metrics',
      items: ENERGY_DISTRIBUTION ?? [],
    },
  },
  tag: 'home',
};

export const EMPTY_ACTIVITY_OVERVIEW = (): Metric => {
  return {
    category: 'ActivityOverview',
    metrics: [
      {
        type: 'TOTAL_BOOKINGS',
        value: 0,
        valueCalc: 0,
        temporality: 'LAST_WEEK',
      },
      {
        type: 'CANCELLATION_WEEK',
        value: 0,
        valueCalc: 0,
        temporality: 'LAST_WEEK',
      },
      {
        type: 'OCCUPANCY_RATE',
        value: 0,
        valueCalc: 0,
        temporality: 'LAST_MONTH',
      },
      {
        type: 'INCOME_MONTH',
        value: 0,
        valueCalc: 0,
        temporality: 'LAST_MONTH',
      },
    ],
  };
};

export const EMPTY_ACCESS_METRICS = (): Metric => {
  return {
    category: 'AccessMetrics',
    metrics: [
      {
        type: 'SUCCESSFUL_ACCESS',
        value: 0,
        valueCalc: 0,
        temporality: 'LAST_WEEK',
      },
      {
        type: 'FAILED_ACCESS',
        value: 0,
        valueCalc: 0,
        temporality: 'LAST_WEEK',
      },
    ],
    recentActivity: [],
  };
};

export const EMPTY_PERFORMANCE_METRICS = (): Metric => ({
  category: 'PerformanceMetrics',
  metrics: [
    { type: 'OCCUPANCY_RATE', value: 0, valueCalc: 0, temporality: 'LAST_MONTH' },
    { type: 'REVENUE_PER_NIGHT', value: 0, valueCalc: 0, temporality: 'PREVIOUS_MONTH' },
    { type: 'CANCELLATION_RATE', value: 0, valueCalc: 0, temporality: 'PREVIOUS_MONTH' },
    { type: 'TOTAL_REVENUE', value: 0, valueCalc: 0, temporality: 'LAST_YEARS' },
    { type: 'TOTAL_BOOKINGS', value: 0, valueCalc: 0, temporality: 'LAST_YEARS' },
    { type: 'AVERAGE_RATING', value: 0, valueCalc: 0, temporality: 'Excellent' },
  ],
});
